// =============================================
// PlanRowStatusCell — jedna komorka akcji (zone / ns / A): w kroku 3 decyzja
// run / skip z powodem, w kroku 4 status wykonania z komunikatem.
// =============================================
import { CheckCircle2, XCircle, MinusCircle, Loader2, Circle, Play } from "lucide-react";
import type { PlannedAction, RowActionStatus } from "@/services/cloudflare/transferTypes";

export const PlannedActionCell = ({ action }: { action: PlannedAction }) => {
  if (action.decision === "run") {
    const detail =
      action.kind === "zone_create" ? "utwórz zonę"
        : action.kind === "ns_set" ? (action.ns === "FROM_CREATED_ZONE" ? "NS z nowej zony" : action.ns.join(", "))
          : `${action.ip}${action.proxied ? " · proxy" : ""}`;
    return (
      <div className="flex items-start gap-1.5 text-xs">
        <Play className="h-3.5 w-3.5 text-emerald-400 shrink-0 mt-0.5" />
        <span className="font-mono break-all">{detail}</span>
      </div>
    );
  }
  return (
    <div className="flex items-start gap-1.5 text-xs text-muted-foreground" title={action.reason}>
      <MinusCircle className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span className="line-clamp-2">{action.reason}</span>
    </div>
  );
};

const ICON: Record<RowActionStatus, React.ReactNode> = {
  pending: <Circle className="h-3.5 w-3.5 text-muted-foreground/40 shrink-0 mt-0.5" />,
  running: <Loader2 className="h-3.5 w-3.5 animate-spin text-blue-400 shrink-0 mt-0.5" />,
  ok: <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 shrink-0 mt-0.5" />,
  failed: <XCircle className="h-3.5 w-3.5 text-red-400 shrink-0 mt-0.5" />,
  skipped: <MinusCircle className="h-3.5 w-3.5 text-muted-foreground shrink-0 mt-0.5" />,
};

export const RunStatusCell = ({ status, message }: { status: RowActionStatus; message?: string }) => (
  <div className={`flex items-start gap-1.5 text-xs ${status === "failed" ? "text-red-400" : status === "skipped" || status === "pending" ? "text-muted-foreground" : ""}`} title={message}>
    {ICON[status]}
    <span className="line-clamp-2 break-all">{message ?? (status === "pending" ? "czeka" : status === "running" ? "w toku…" : "")}</span>
  </div>
);
